import { useQuery } from "@tanstack/react-query";
import { getMe } from "@/lib/gql/getMe";
import { useUserStore } from "@/store/useUser";
import { useEffect } from "react";

export function useMe() {
  const { setUser, clearUser } = useUserStore();

  const query = useQuery({
    queryKey: ["me"],
    queryFn: getMe,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });

  useEffect(() => {
    if (query.data) {
      setUser(query.data);
    }
  }, [query.data, setUser]);

  useEffect(() => {
    if (query.isError) {
      clearUser();
    }
  }, [query.isError, clearUser]);

  return query;
}
